import { CacaoService } from './cacao.service';
import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Balance } from '../models/balances';

@Injectable({
  providedIn: 'root'
})
export class BalancesService {

  balanceCollection: AngularFirestoreCollection<Balance>;
  balanceDoc: AngularFirestoreDocument<Balance>;
  balances: Observable<Balance[]>;
  balance: Observable<Balance>;

  constructor(
    private afs: AngularFirestore,
    private cacaoService: CacaoService
  ) {
    this.balanceCollection = this.afs.collection('balances');
  }

  getCompanyBalance(id: string): Observable<Balance | any> {
    const diespersionsObj = this.afs.collection<Balance>('balances', ref => ref.where('companyId', '==', id).limit(1))
      .valueChanges();
    return diespersionsObj;
  }

  getBalances(): Observable<Balance[]> {
    // Get items with the id
    this.balances = this.balanceCollection.snapshotChanges().pipe(
      map((changes) => {
        return changes.map((action) => {
          const data = action.payload.doc.data() as Balance;
          data.id = action.payload.doc.id;
          return data;
        });
      })
    );

    return this.balances;
  }

  getBalance(id: string): Observable<Balance> {
    this.balanceDoc = this.afs.doc<Balance>(`balances/${id}`);
    this.balance = this.balanceDoc.snapshotChanges().pipe(
      map((action) => {
        if (action.payload.exists === false) {
          return null;
        } else {
          const data = action.payload.data() as Balance;
          data.id = action.payload.id;
          return data;
        }
      })
    );
    return this.balance;
  }

  newBalance(balance: Balance): Promise<{ balance: Balance } | any> {
    return new Promise(async (resolve, reject) => {
      try {
        const savingNewBalance = await this.balanceCollection.add(
          JSON.parse(JSON.stringify(balance))
        );
        resolve(savingNewBalance.id);
        const myObj: any = {};
        myObj.id = savingNewBalance.id;
        this.updateBalance(myObj.id, myObj);
      } catch (err) {
        reject(err);
      }
    });
  }

  async updateBalance(
    docId: string,
    newData: any
  ): Promise<{ balance: Balance } | any> {
    try {
      let response = await this.afs.doc(`balances/${docId}`).update(newData);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  getIhunterBalance() {
    // aqui tenemos que consumir el servicio de Cacao para obtener el balance de la cuenta consentradora de this.getIhunterBalance
    let balance;
    return this.cacaoService.getBalance().toPromise()
    .then((result: any) => {
      if(result && result.data) {
        balance = result.data.SaldoActual.find(s => s.ClaveTipoCuenta.trim() == 'CCLC');
        return balance ? balance.Saldo : 0;
      }
    })
    .catch(err => {
      console.log(err);
      return 0;
    });
  }

  deleteBalance() { }
}
